module.exports = __webpack_public_path__ + "static/img/book.3768c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/book.png
// module id = vzgd
// module chunks = 1